import EmailLinkToken from 'features/auth/components/EmailLinkToken/EmailLinkToken';
import React from 'react';

export default function Page() {
  return <EmailLinkToken />;
}
